// CreateAdmin.tsx
import React, { useState } from "react";

import {
  Modal,
  TextInput,
  PasswordInput,
  Text,
  Button,
  Group,
  Select,
} from "@mantine/core";
import { RowDataAdmin } from "./types";

import classes from "./Admin.module.css";

interface CreateAdminProps {
  isVisible: boolean;
  onClose: () => void;
  onAddAdmin: (newAdmin: RowDataAdmin) => void;
}

const CreateAdmin: React.FC<CreateAdminProps> = ({
  isVisible,
  onClose,
  onAddAdmin,
}) => {
  const [newAdmin, setNewAdmin] = useState<RowDataAdmin>({
    name: "",
    uid: "",
    email: "",
    password: "",
    reenterPassword: "",
    action: "",

    role: "admin",
  });

  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handleAddAdmin = () => {
    // Check if any field is empty
    if (
      !newAdmin.name ||
      !newAdmin.email ||
      !newAdmin.password ||
      !newAdmin.reenterPassword
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    // Check if the passwords match
    const passwordsMatch = newAdmin.password === newAdmin.reenterPassword;

    if (!passwordsMatch) {
      alert("Passwords do not match");
      setPasswordsMatch(false);
      return;
    }

    // Validation passed, proceed with adding the customer
    onAddAdmin({
      ...newAdmin,
      action: "Add",
    });

    setNewAdmin({
      name: "",
      uid: "",
      email: "",
      password: "",
      reenterPassword: "",
      action: "",

      role: "admin",
    });

    onClose();
  };

  return (
    <Modal
      opened={isVisible}
      onClose={onClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>New Admin</div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddAdmin();
        }}
      >
        <TextInput
          label="Name"
          placeholder="Enter admin full name (eg. John Doe)"
          mb="sm"
          value={newAdmin.name}
          maxLength={255}
          required
          onChange={(e) =>
            setNewAdmin({ ...newAdmin, name: e.currentTarget.value })
          }
        />

        <TextInput
          label="Email"
          placeholder="name@example.com"
          mb="sm"
          maxLength={255}
          value={newAdmin.email}
          required
          onChange={(e) =>
            setNewAdmin({ ...newAdmin, email: e.currentTarget.value })
          }
        />

    <Select
        label="Admin Type"
        data={[{ value: 'admin', label: 'Admin' }, { value: 'manager', label: 'Manager' }, { value: 'content', label: 'Content' }, { value: 'price-list', label: 'Price List' }]}
        value={newAdmin.role}
        onChange={(_value, option) => setNewAdmin({...newAdmin, role: option.value})}
        required
        mb="sm"
    />

        <PasswordInput
          value={newAdmin.password}
          mb="sm"
          maxLength={255}
          onChange={(e) =>
            setNewAdmin({ ...newAdmin, password: e.currentTarget.value })
          }
          placeholder="Your password"
          label="Password"
          required
        />

        <PasswordInput
          value={newAdmin.reenterPassword}
          maxLength={255}
          mb="sm"
          onChange={(e) => {
            setNewAdmin({
              ...newAdmin,
              reenterPassword: e.currentTarget.value,
            });
            setPasswordsMatch(newAdmin.password === e.currentTarget.value);
          }}
          placeholder="Reenter your password"
          label="Reenter Password"
          required
        />

        {!passwordsMatch && (
          <Text color="red" mt="sm">
            Passwords do not match
          </Text>
        )}
        <Group className={classes.buttonBottom}>
          <Button onClick={() => onClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button type="submit" className={classes.buttonSaveChanges}>
            Submit{" "}
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default CreateAdmin;
